/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Results_Noresults1Inputs */

const id_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada hasil ditemukan`)
};

const ms_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada hasil ditemui`)
};

const da_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater fundet`)
};

const de_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse gefunden`)
};

const en_us2_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const es_es2_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const es_mx2_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const fil_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang resulta`)
};

const fr_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat trouvé`)
};

const it_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato`)
};

const hu_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs találat`)
};

const nl_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten gevonden`)
};

const no_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater funnet`)
};

const pl_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono wyników`)
};

const pt_br2_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado`)
};

const pt_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado`)
};

const ro_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit rezultate`)
};

const fi_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tuloksia`)
};

const sv_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga resultat hittades`)
};

const vi_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy kết quả`)
};

const tr_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç bulunamadı`)
};

const cs_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné výsledky`)
};

const bg_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени резултати`)
};

const ru_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты не найдены`)
};

const uk_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результатів не знайдено`)
};

const ar_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على نتائج`)
};

const hi_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई परिणाम नहीं मिला`)
};

const th_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผลลัพธ์`)
};

const ja_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果が見つかりません`)
};

const zh_cn2_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到结果`)
};

const zh_hant1_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到結果`)
};

const ko_search_results_noresults1 = /** @type {(inputs: Search_Results_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 결과가 없습니다`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Search_Results_Noresults1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_results_noresults1 = /** @type {((inputs?: Search_Results_Noresults1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Results_Noresults1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_results_noresults1(inputs)
	if (locale === "ms") return ms_search_results_noresults1(inputs)
	if (locale === "da") return da_search_results_noresults1(inputs)
	if (locale === "de") return de_search_results_noresults1(inputs)
	if (locale === "en-US") return en_us2_search_results_noresults1(inputs)
	if (locale === "es-ES") return es_es2_search_results_noresults1(inputs)
	if (locale === "es-MX") return es_mx2_search_results_noresults1(inputs)
	if (locale === "fil") return fil_search_results_noresults1(inputs)
	if (locale === "fr") return fr_search_results_noresults1(inputs)
	if (locale === "it") return it_search_results_noresults1(inputs)
	if (locale === "hu") return hu_search_results_noresults1(inputs)
	if (locale === "nl") return nl_search_results_noresults1(inputs)
	if (locale === "no") return no_search_results_noresults1(inputs)
	if (locale === "pl") return pl_search_results_noresults1(inputs)
	if (locale === "pt-BR") return pt_br2_search_results_noresults1(inputs)
	if (locale === "pt") return pt_search_results_noresults1(inputs)
	if (locale === "ro") return ro_search_results_noresults1(inputs)
	if (locale === "fi") return fi_search_results_noresults1(inputs)
	if (locale === "sv") return sv_search_results_noresults1(inputs)
	if (locale === "vi") return vi_search_results_noresults1(inputs)
	if (locale === "tr") return tr_search_results_noresults1(inputs)
	if (locale === "cs") return cs_search_results_noresults1(inputs)
	if (locale === "bg") return bg_search_results_noresults1(inputs)
	if (locale === "ru") return ru_search_results_noresults1(inputs)
	if (locale === "uk") return uk_search_results_noresults1(inputs)
	if (locale === "ar") return ar_search_results_noresults1(inputs)
	if (locale === "hi") return hi_search_results_noresults1(inputs)
	if (locale === "th") return th_search_results_noresults1(inputs)
	if (locale === "ja") return ja_search_results_noresults1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_results_noresults1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_results_noresults1(inputs)
	return ko_search_results_noresults1(inputs)
});
export { search_results_noresults1 as "search.results.noResults" }